import React, { useEffect, useState } from 'react';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import ComponentPageTitle from '../../../components/PageTitle';
import CenteredContainer from '../../../components/CenteredContainer';
import PageName from '../../../components/PageName';
import Spacer from '../../../components/Spacer';
import { Sushiwari } from '../thumbnail_images';

import { workData, workPlanData } from '../WorkData';
import ComponentCategoryInfomation from '../ComponentCategoryInfomation';
import ComponentHoverLinkTile from '../mini_components/ComponentHoverLinkTile';
import ComponentProfileTile from '../../Profile/ComponentProfileTile';
import ProductPageH2 from '../mini_components/ComponentProductPageH2';
import ShinagawaRunners1 from '../../../assets/images/product_pages/shinagawa_runners/shinagawa_runners_1.png';
import ShinagawaRunners2 from '../../../assets/images/product_pages/shinagawa_runners/shinagawa_runners_2.png';
import ShinagawaRunners3 from '../../../assets/images/product_pages/shinagawa_runners/shinagawa_runners_3.png';
import ShinagawaRunners4 from '../../../assets/images/product_pages/shinagawa_runners/shinagawa_runners_4.png';
import ShinagawaRunners5 from '../../../assets/images/product_pages/shinagawa_runners/shinagawa_runners_5.png';
import ShinagawaRunners6 from '../../../assets/images/product_pages/shinagawa_runners/shinagawa_runners_6.png';
import PreviewGoogleDrivePdf from '../../../components/PreviewGoogleDrivePdf';
import CircleNum from '../mini_components/CircleNum';

import { ArrowDownwardOutlined, Spa } from '@mui/icons-material';
import CircleNumP from '../mini_components/CircleNumP';
import ComponentProductHeader from '../mini_components/ComponentProductHeader';



const ProductShinagawaRunners = () => {
    const sushiwariData = workData.find(item => item.title === "品川ランナーズ");
    const [isDesktop, setIsMobile] = useState(window.innerWidth > 767);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth > 767);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    PageName("品川ランナーズ - 制作物");

    return (<>
        <Header />
        <CenteredContainer>
        <ComponentPageTitle title="品川ランナーズ - 制作物" />

        {/* ================================================= 冒頭部分 ================================================= */}
        <ComponentProductHeader isDesktop={isDesktop} data={sushiwariData} customImageSize='27%' customImageAlign='flex-end' />
        {/* ========================================================================================================== */}


        {/* ============================================= 募集されたテーマ ============================================== */}
        <ProductPageH2>募集されたテーマ</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>「未来の品川に必要なアイデア」というテーマが募集されました。</p>
        </ul>
        {/* ========================================================================================================== */}


        {/* =============================================== 旧東海道とは ================================================ */}
        <ProductPageH2>旧東海道とは</ProductPageH2>
        <ul>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px'
            }}>
                <img src={ShinagawaRunners5} alt="旧東海道1" style={{ width: '100%', maxWidth: '270px' }} />
                旧東海道とは、江戸時代頃に人馬と情報の往来幹線としてできた江戸-京都間の道です。
            </p>
            <Spacer height={30} />
            <p style={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px'
            }}>
                <img src={ShinagawaRunners6} alt="旧東海道2" style={{ width: '100%', maxWidth: '270px' }} />
                ピンク色の部分で品川区内も通り、古き良き街並みや施設が見られます。
            </p>
        </ul>
        {/* ========================================================================================================== */}


        {/* =============================================== アイデア詳細 ================================================ */}
        <ProductPageH2>アイデア詳細</ProductPageH2>
        <ul style={{ display: 'flex', flexWrap: 'wrap', gap: '40px 15px', fontSize: '110%' }}>
            <p>品川区内の旧東海道をランニングコースとして活用し、次の3つの角度からランニングを支援するビジネスアイデア</p>
            <p>
                <CircleNum>1</CircleNum>
                <p style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginLeft: '40px'
                }}>
                    <img src={ShinagawaRunners1} alt="アイデア詳細1-1" style={{ width: '100%', maxWidth: '130px', margin: '10px 0' }} />
                    ランニングの前後にランナーたちがストレッチをすることができるスペースを設ける
                </p>
                <Spacer height={20} />
                <p style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginLeft: '40px'
                }}>
                    <img src={ShinagawaRunners2} alt="アイデア詳細1-2" style={{ width: '100%', maxWidth: '130px', margin: '10px 0' }} />
                    さらに飲料・栄養ドリンク・健康食品・タオルなどの販売機も用意する
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>2</CircleNum>
                <p style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginLeft: '40px'
                }}>
                    <img src={ShinagawaRunners3} alt="アイデア詳細1-1" style={{ width: '100%', maxWidth: '130px', margin: '10px 0' }} />
                    更衣室・シャワー・ロッカー・ウェアやシューズのレンタル/販売を備えた<br />ランニングステーションの設置
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>3</CircleNum>
                <p style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    marginLeft: '40px'
                }}>
                    <img src={ShinagawaRunners4} alt="アイデア詳細1-1" style={{ width: '100%', maxWidth: '240px', margin: '0' }} />
                    <div>
                        <p>現在、品川区が提供している「品川ウォーキングマップ」には、<br />地図・歩数計・足あと などの機能があり、これらに次の機能を追加する：</p>
                        <ol style={{ marginLeft: '15px', marginTop: '10px' }}>
                            <li style={{margin: '7px 0'}}>現在、ウォーキングに特化しているため、ランニングにも対応する</li>
                            <li style={{margin: '7px 0'}}>ランニング中の天気の不安を解消するため、天気予報や雨が降る通知を利用できるようにする</li>
                            <li style={{margin: '7px 0'}}>一緒に走りたい人同士をマッチングする機能を搭載し、地域交流の活性化を促進・ランナーのモチベーション向上に繋げる</li>
                            <li style={{margin: '7px 0'}}>地図で区内の銭湯・飲食店・マッサージ店を表示し、ランニング後の肉体的・精神的なケアの提供・地域経済に貢献する</li>
                            <li style={{margin: '7px 0'}}>アプリ内に広告を表示し、収入源の1つとする</li>
                            <li style={{margin: '7px 0'}}>ランニングに関するきめ細かい情報をサブスクリプション加入者限定で公開し、ランナーのモチベーション向上や運営の収入源に繋げる</li>
                        </ol>
                    </div>
                </p>
            </p>


        </ul>
        {/* ========================================================================================================== */}


        {/* =============================================== 考案した経緯 ================================================ */}
        <ProductPageH2>考案した経緯</ProductPageH2>
        <ul>
            <p>現状として、風情ある旧東海道の魅力に気づいていない人が多く、未来に魅力を伝えていくためには、多くの人に楽しみながら知ってもらう必要があると考えました。</p>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', color: 'var(--common-main-color)', margin: '18px 0' }}><ArrowDownwardOutlined /></div>
            <p>ランニングを通して魅力を知ってもらうことが優れた方法だと考えたため、このアイデアを考案しました。</p>
        </ul>
        {/* ========================================================================================================== */}


        {/* ==================================== ユーザーの使いやすさのために工夫した点 ===================================== */}
        <ProductPageH2>ユーザーのために工夫した点</ProductPageH2>
        <ul>
            <p><CircleNum>1</CircleNum>ただランニングするだけでなく、天気やケアなどにより快適に楽しめるよう工夫しました。</p>
            <Spacer height={30} />
            <p><CircleNum>2</CircleNum>サブスクや地元の飲食点など、提供者や地域にもメリットを生み、ビジネスモデルとして形成できるよう工夫しました。</p>
        </ul>
        {/* ========================================================================================================== */}

        </CenteredContainer>
        <Footer />
    </>);
};



export default ProductShinagawaRunners;